import { inject as baseInject, interfaces } from 'inversify';

import { getOverrideTarget } from '../utils/override-target-getter';

export function inject<T = unknown>(serviceIdentifier: interfaces.Newable<T>) {
  return baseInject(getOverrideTarget(serviceIdentifier));
}
